import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MailIcon, LockIcon, UserIcon, PhoneIcon, ArrowLeftIcon } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
export function Register() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    navigate('/auth/otp');
  };
  return <div className="w-full h-full bg-black flex flex-col" data-id="element-266">
      {/* Header */}
      <div className="px-4 py-6 flex items-center" data-id="element-267">
        <button onClick={() => navigate(-1)} className="p-2 -ml-2 text-white hover:bg-surface rounded-full transition-colors" data-id="element-268">
          <ArrowLeftIcon size={24} data-id="element-269" />
        </button>
      </div>

      <div className="flex-1 px-6 pb-6 overflow-y-auto no-scrollbar" data-id="element-270">
        <div className="mb-8" data-id="element-271">
          <h1 className="text-3xl font-poppins font-bold text-white mb-2" data-id="element-272">
            Create Account
          </h1>
          <p className="text-softGray" data-id="element-273">Join the funniest community online.</p>
        </div>

        <form onSubmit={handleSubmit} className="flex flex-col gap-4" data-id="element-274">
          <Input label="Username" placeholder="@username" icon={<UserIcon size={20} data-id="element-276" />} data-id="element-275" />

          <Input label="Email" placeholder="name@example.com" icon={<MailIcon size={20} data-id="element-278" />} type="email" data-id="element-277" />

          <Input label="Phone Number" placeholder="+1 (555) 000-0000" icon={<PhoneIcon size={20} data-id="element-280" />} type="tel" data-id="element-279" />

          <div className="relative" data-id="element-281">
            <Input label="Password" placeholder="Create a password" icon={<LockIcon size={20} data-id="element-283" />} type={showPassword ? 'text' : 'password'} data-id="element-282" />
            <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-4 top-[38px] text-softGray text-sm font-medium" data-id="element-284">
              {showPassword ? 'Hide' : 'Show'}
            </button>
          </div>

          <label className="flex items-start gap-3 mt-2 cursor-pointer" data-id="element-285">
            <input type="checkbox" className="mt-1 w-4 h-4 rounded border-border bg-surface text-primary focus:ring-primary focus:ring-offset-black" required data-id="element-286" />
            <span className="text-sm text-softGray leading-tight" data-id="element-287">
              I agree to the{' '}
              <span className="text-primary" data-id="element-288">Terms of Service</span> and{' '}
              <span className="text-primary" data-id="element-289">Privacy Policy</span>.
            </span>
          </label>

          <Button type="submit" className="mt-6" data-id="element-290">
            Create Account
          </Button>
        </form>

        <div className="mt-8 text-center pb-8" data-id="element-291">
          <p className="text-softGray text-sm" data-id="element-292">
            Already have an account?{' '}
            <button onClick={() => navigate('/auth/login')} className="text-primary font-bold" data-id="element-293">
              Log in
            </button>
          </p>
        </div>
      </div>
    </div>;
}